var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('elw-button',{class:{ blinkButton: _vm.isEditing },attrs:{"type":"primary","size":"mini"},on:{"click":_vm.click}},[_vm._v("保存")])}
var staticRenderFns = []

export { render, staticRenderFns }